import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import { CreatableSelect, components, mergeStyles } from '@atlaskit/select';
import { format, isValid, parse } from 'date-fns';
import pick from 'lodash.pick';
import React, { Component } from 'react';
import { colors } from '@atlaskit/theme';

import { ClearIndicator, defaultTimes, DropdownIndicator as _DropdownIndicator } from '../internal';
import FixedLayer from '../internal/FixedLayer';

/* eslint-disable react/no-unused-prop-types */


function dateFromTime(time) {
  var _ref = time.match(/(\d\d):(\d\d)/) || [],
      _ref2 = _slicedToArray(_ref, 2),
      h = _ref2[0],
      m = _ref2[1];

  return h && m ? parse('0000-00-00T' + h + ':' + m) : new Date('invalid date');
}

function formatTime(time) {
  var date = dateFromTime(time);
  return isValid(date) ? format(date, 'h:mma') : time;
}

var menuStyles = {
  /* Need to remove default absolute positioning as that causes issues with position fixed */
  position: 'static',
  /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */
  overflowY: 'auto'
};

var TimePicker = function (_Component) {
  _inherits(TimePicker, _Component);

  function TimePicker() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, TimePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = TimePicker.__proto__ || _Object$getPrototypeOf(TimePicker)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      isOpen: _this.props.defaultIsOpen,
      value: _this.props.defaultValue,
      isFocused: false
    }, _this.getState = function () {
      return _extends({}, _this.state, pick(_this.props, ['value', 'isOpen']));
    }, _this.onChange = function (v) {
      var value = v ? v.value : '';
      _this.setState({ value: value });
      _this.props.onChange(value);
    }, _this.onCreateOption = function (inputValue) {
      var value = inputValue || '';
      if (_this.props.timeIsEditable) {
        _this.setState({ value: value });
        _this.props.onChange(value);
      } else {
        _this.onChange(inputValue);
      }
    }, _this.onMenuOpen = function () {
      _this.setState({ isOpen: true });
    }, _this.onMenuClose = function () {
      _this.setState({ isOpen: false });
    }, _this.getContainerRef = function (ref) {
      var oldRef = _this.containerRef;
      _this.containerRef = ref;
      // Cause a re-render if we're getting the container ref for the first time
      // as the layered menu requires it for dimension calculation
      if (oldRef == null && ref != null) {
        _this.forceUpdate();
      }
    }, _this.onBlur = function () {
      _this.setState({ isFocused: false });
      _this.props.onBlur();
    }, _this.onFocus = function () {
      _this.setState({ isFocused: true });
      _this.props.onFocus();
    }, _this.getSubtleControlStyles = function (selectStyles) {
      if (selectStyles.control) return {};
      return {
        border: '2px solid ' + (_this.getState().isFocused ? '' + colors.B100 : 'transparent'),
        backgroundColor: 'transparent',
        padding: '1px'
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // All state needs to be accessed via this function so that the state is mapped from props
  // correctly to allow controlled/uncontrolled usage.


  _createClass(TimePicker, [{
    key: 'getOptions',
    value: function getOptions() {
      return this.props.times.map(function (time) {
        return {
          label: formatTime(time),
          value: time
        };
      });
    }

    /** Only allow custom times if timeIsEditable prop is true  */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoFocus = _props.autoFocus,
          id = _props.id,
          innerProps = _props.innerProps,
          isDisabled = _props.isDisabled,
          name = _props.name,
          selectProps = _props.selectProps;

      var _getState = this.getState(),
          value = _getState.value,
          isOpen = _getState.isOpen;

      var validationState = this.props.isInvalid ? 'error' : 'default';
      var icon = this.props.appearance === 'subtle' || this.props.hideIcon ? null : this.props.icon;
      var FixedLayerMenu = function FixedLayerMenu(props) {
        return React.createElement(FixedLayer, {
          containerRef: _this2.containerRef,
          content: React.createElement(components.Menu, _extends({}, props, { scrollMenuIntoView: false }))
        });
      };

      var _selectProps$styles = selectProps.styles,
          selectStyles = _selectProps$styles === undefined ? {} : _selectProps$styles,
          otherSelectProps = _objectWithoutProperties(selectProps, ['styles']);

      var controlStyles = this.props.appearance === 'subtle' ? this.getSubtleControlStyles(selectStyles) : {};

      return React.createElement(
        'div',
        _extends({}, innerProps, { ref: this.getContainerRef }),
        React.createElement('input', { name: name, type: 'hidden', value: value }),
        React.createElement(CreatableSelect, _extends({
          autoFocus: autoFocus,
          components: {
            ClearIndicator: ClearIndicator,
            DropdownIndicator: function DropdownIndicator() {
              return React.createElement(_DropdownIndicator, { icon: icon });
            },
            Menu: FixedLayerMenu
          },
          instanceId: id,
          isDisabled: isDisabled,
          menuIsOpen: isOpen && !isDisabled,
          menuPlacement: 'auto',
          onBlur: this.onBlur,
          onCreateOption: this.onCreateOption,
          onChange: this.onChange,
          options: this.getOptions(),
          onFocus: this.onFocus,
          onMenuOpen: this.onMenuOpen,
          onMenuClose: this.onMenuClose,
          placeholder: 'e.g. 9:00am',
          styles: mergeStyles(selectStyles, {
            control: function control(base) {
              return _extends({}, base, controlStyles);
            },
            menu: function menu(base) {
              return _extends({}, base, menuStyles, {
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: _this2.containerRef ? _this2.containerRef.getBoundingClientRect().width : 'auto'
              });
            }
          }),
          value: value && {
            label: formatTime(value),
            value: value
          }
        }, otherSelectProps, {
          validationState: validationState
        }))
      );
    }
  }]);

  return TimePicker;
}(Component);

TimePicker.defaultProps = {
  appearance: 'default',
  autoFocus: false,
  isDisabled: false,
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  times: defaultTimes,
  selectProps: {},
  innerProps: {},
  id: '',
  defaultIsOpen: false,
  defaultValue: '',
  timeIsEditable: false,
  isInvalid: false,
  hideIcon: false
};
export default TimePicker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/datetime-picker/dist/esm/components/TimePicker.js
// module id = 235
// module chunks = 0